import { FormEvent, useContext, useState } from "react";
import { BackSvgPPP, CrossIconSvgPPP, OffersIconSvgPPP } from "../svgImages";
import PublicModalWrapper from "../PublicModalWrapper";
import BankOfferModal from "../PublicModalWrapper/BankOfferModal";
import { applyQuotationCouponCode, removeQuotationCouponCode } from "../../../../api/quotation.api";
import { useParams } from "react-router-dom";
import SnackbarContext from "../../../../context/snackbar.context";
import "./style.scss";
import { Spinner } from "react-bootstrap";
import RemoveCouponModal from "../PublicModalWrapper/RemoveCouponModal";

interface ICouponCodeCard{
  getQuotationData: () => void;
  couponDetails: { couponCode: string, successMessage: string };
  partialPayment: boolean;
}

const CouponCodeCard: React.FC<ICouponCodeCard> = ({ getQuotationData, couponDetails, partialPayment = false }) => {
  const params = useParams();
  const { quotationId = '' } = params;
  const snackbarCtx = useContext(SnackbarContext);
  
  // const [trigger, setTrigger] = useState<boolean>(false);
  const [couponCodeDetails, setCouponCodeDetails] = useState<{ couponCode: string; couponDesc: string }>({
    couponCode: couponDetails?.couponCode || "",
    couponDesc: couponDetails?.successMessage || "",
  });
  const [loader, setLoader] = useState<boolean>(false);

  const [confirmationModal, setConfirmationModal] = useState<boolean>(false);
  // const [modalViewState, setModalViewState] = useState<boolean>(false);
  // const [bankName, setBankName] = useState<string>("");

  const handleInputChange = (e: any) => {
    setCouponCodeDetails({ ...couponCodeDetails, couponCode: e.target.value });
  };

  const handleCodeApply = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);
    const response = await applyQuotationCouponCode({
      quotationId: quotationId,
      coupon_code: couponCodeDetails?.couponCode,
      partial_payment: partialPayment
    })
    if (response?.status === 201) {
      setCouponCodeDetails({ ...couponCodeDetails, couponDesc: response?.result?.success_message });
      getQuotationData();
      snackbarCtx.toggleSnackbar({
        message: 'Coupon Code Applied !!',
        type: "SUCCESS",
        visible: true,
      });
    } else {
      snackbarCtx.toggleSnackbar({
      message: response?.response?.data?.message || 'Something went wrong !!',
      type: "FAILURE",
      visible: true,
      });
    }
    setLoader(false);
  };

  const handleCodeRemove = async () => {
    const response = await removeQuotationCouponCode(quotationId)
    if (response?.status === 200) {
      setCouponCodeDetails({ couponCode: '', couponDesc: '' });
      getQuotationData();
      setConfirmationModal(false);
      snackbarCtx.toggleSnackbar({
        message: 'Coupon Code Removed !!',
        type: "FAILURE",
        visible: true,
      });
    } else {
      snackbarCtx.toggleSnackbar({
      message: response?.response?.data?.message || 'Something went wrong !!',
      type: "FAILURE",
      visible: true,
    });}
  };

  // const handleTermsClick = (bankName: string) => {
  //   setModalViewState(true);
  //   setBankName(bankName);
  // }

  // const handleOfferClick = (offerCode: string) => { 
  //   setCouponCode(offerCode);
  //   setCouponSuccess(true);
  // }

  return (
    <div className="coupon-code-card-wrapper">
      <span className="coupon-code-card-text">Apply Coupon</span>
      <form className="coupon-code-card-input-wrapper" onSubmit={handleCodeApply}>
        <div>
          <input
            type="text"
            name="coupon-code-input"
            id="coupon-code-input"
            onChange={handleInputChange}
            // value={couponCode?.toUpperCase()}
            value={couponCodeDetails?.couponCode}
            disabled={!!couponCodeDetails?.couponDesc || loader}
          />
          {!!couponCodeDetails?.couponDesc && (
            <button type="button" title="Remove Coupon" onClick={() => setConfirmationModal(true)}>
              <CrossIconSvgPPP />
            </button>
          )}
        </div>
        <button type="submit" className={`${!!couponCodeDetails?.couponDesc ? "green-bg" : ""}`} disabled={!!couponCodeDetails?.couponDesc || loader || !couponCodeDetails?.couponCode?.trim()}>
          {!couponCodeDetails?.couponDesc ? "Apply" : "Applied"}
          {loader && <Spinner size="sm" />}
        </button>
      </form>
      {!!couponCodeDetails?.couponDesc && <span className="coupon-code-card-desc-text">{couponCodeDetails?.couponDesc}</span>}
      {/* <div className={`coupon-code-card-coupons-wrapper ${trigger ? 'add-padding' : ''}`}>
        {trigger && (
          <div className="bank-offers-wrapper">
            <div className="bank-offer">
              <div>
                <span className="bank-name">HDFC Bank Offer</span>
                <span className="terms-conditions" onClick={() => handleTermsClick("HDFC")}>T&C's</span>
              </div>
              <span className="apply-button" onClick={() => handleOfferClick('HDFC20')}>APPLY</span>
            </div>
            <div className="bank-offer">
              <div>
                <span className="bank-name">IDFC Bank Offer</span>
                <span className="terms-conditions" onClick={() => handleTermsClick("IDFC")}>T&C's</span>
              </div>
              <span className="apply-button" onClick={() => handleOfferClick('IDFC20')}>APPLY</span>
            </div>
            <div className="bank-offer">
              <div>
                <span className="bank-name">AXIS Bank Offer</span>
                <span className="terms-conditions" onClick={() => handleTermsClick("AXIS")}>T&C's</span>
              </div>
              <span className="apply-button" onClick={() => handleOfferClick('AXIS20')}>APPLY</span>
            </div>
          </div>
        )}
        <div className="view-button-wrapper">
          <OffersIconSvgPPP />
          <div onClick={() => setTrigger((prev) => !prev)}>
            <span>{trigger ? "Hide" : "View"} Offers</span>
            <span className={`${trigger ? "open" : "close"}`}>
              <BackSvgPPP height={12} fill="#008CFF" />
            </span>
          </div>
        </div>
      </div> */}
      <PublicModalWrapper show={confirmationModal} handleClose={() => setConfirmationModal(false)} wantCloseIcon={false} clx={'remove-coupon-modal-wrapper'}>
        <RemoveCouponModal couponCode={couponCodeDetails?.couponCode} handleClose={setConfirmationModal} handleCodeRemove={handleCodeRemove} />
      </PublicModalWrapper>
      {/* <PublicModalWrapper show={modalViewState} handleClose={() => setModalViewState(false)}>
        <BankOfferModal bankOfferDetails={bankName}/>
      </PublicModalWrapper> */}
    </div>
  );
};

export default CouponCodeCard;
